"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var experiment_context_1 = require("@shared-ui/experiment-context");
var utils_1 = require("./utils");
var _1 = require(".");
var RedirectBanner = (function (_super) {
    __extends(RedirectBanner, _super);
    function RedirectBanner(props) {
        return _super.call(this, props) || this;
    }
    RedirectBanner.prototype.render = function () {
        return (React.createElement(experiment_context_1.Experiment, { name: "ME_Redirect_Banner_Bottom_Placement" },
            React.createElement(experiment_context_1.ExperimentControl, null,
                React.createElement(_1.RedirectBannerComponents, { siteid: this.props.siteid, locale: this.props.locale, langid: this.props.langid, countryCode: this.props.countryCode, domainOverride: this.props.domainOverride, spoofLocation: this.props.spoofLocation, expVariant: utils_1.ExpVariant.CONTROL })),
            React.createElement(experiment_context_1.ExperimentVariant, { bucket: 1 },
                React.createElement(_1.RedirectBannerComponents, { siteid: this.props.siteid, locale: this.props.locale, langid: this.props.langid, countryCode: this.props.countryCode, domainOverride: this.props.domainOverride, spoofLocation: this.props.spoofLocation, expVariant: utils_1.ExpVariant.VARIANT_1 }))));
    };
    return RedirectBanner;
}(React.Component));
exports.RedirectBanner = RedirectBanner;
//# sourceMappingURL=redirect-banner.js.map